import React, { useState, useEffect } from "react";
import "./intro.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Swal from "sweetalert2"; // Import SweetAlert2 for better UI feedback
// import desktopBg from "../../img/desktop.png";
// import mobBg from "../../img/mob.png";
import logo from "../../img/logo.png";

function Intro({ updateHeader }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [themeData, setThemeData] = useState(null);
  // const [riddlerusLogo, SetriddlerusLogo] = useState("../img/logo.png");
  const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
  //const themeData1 = JSON.parse(sessionStorage.getItem('themeData'));
  const [rules, setRules] = useState(["", "", ""]);
  const [textcolor, Setcolorcode] = useState(null);


  useEffect(() => {

    updateHeader({
      backButtonRedirect: "/login?save=true"
    });

  }, [navigate]);

  useEffect(() => {
    setRules([
      "Complete all 5 stages in order to solve the Republic Day heist.",
      "Find clues + solve puzzles to unlock the next stage.",
      "Engage in all games with your team to enlighten yourself and also earn points.",
      "Win the game by completing the final mission and recovering the mint plates."
    ]);
  }, []);

  return (
    <>
      <div className="intro-page-bg-1">

        <div className="intro-main-container-1" style={{ textAlign: "center" }}>
          <div className="intro-main-container1" style={{ textAlign: "center" }}>
            <img src={logo} className="intro-logo-1" />
          </div>

          <div className="text-main-container" style={{ textAlign: "center" }}>
            <h4 style={{ color: textcolor }} id="logintext">RULES</h4>
          </div>

          <div>
            <ul className="rules-intro">
              {rules.map((rule, index) => (
                <li key={index}>{rule}</li>
              ))}
            </ul>

          </div>

          <div style={{ textAlign: "center" }}>
            <Link to="/rules">
              {/* <img src="/img/next-button.png" className="begin-play-img" /> */}
              <button type="button" className="begin-play-btn submit-btn-intro-1">
                Next
              </button>
            </Link>
          </div>
        </div>
      </div>

    </>

  );

}
export default Intro;